import * as types from '../../types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

const INITIAL_STATE = Immutable.fromJS({
    saving: false,
    filter: '',
    modalCreate: {
        show: false,
        data: null
    },
    modalCreatePresupuesto: {
        show: false,
        data: null
    },
    modalCargarPresupuesto: {
        show: false,
        data: {}
    }
})

export default function (state = INITIAL_STATE, action) {
    let temp
    switch (action.type) {
        case types.CENCOS_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.CENCOS_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        case types.CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE:
            state = state.setIn(['modalCreate', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(action.payload.item))
            } else {
                state = state.set('modalCreate', INITIAL_STATE.get('modalCreate'))
            }
            return state
        case types.CENCOS_ACTUALIZAR_REGISTROS:
            temp = diff(state.getIn(`cencos.data.${action.payload.id}`.split('.')), Immutable.fromJS(action.payload.item))
            state = state.setIn(`cencos.data.${action.payload.id}`.split('.'), patch(state.getIn(`cencos.data.${action.payload.id}`.split('.')), temp))
            return state
        case types.CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE_PRESUPUESTO:
            state = state.setIn(['modalCreatePresupuesto', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreatePresupuesto', 'data'], Immutable.fromJS(action.payload.item))
            } else {
                state = state.set('modalCreatePresupuesto', INITIAL_STATE.get('modalCreatePresupuesto'))
            }
            return state
        case types.CENCOS_ACTUALIZAR_PRESUPUESTOS:
            temp = state.getIn('modalCreatePresupuesto.data.id3n71f13r'.split('.'))
            state = state.setIn(`modalCreate.data.tables.presupuestos.data.${temp}`.split('.'), state.getIn('modalCreatePresupuesto.data'.split('.')))
            return state
        case types.CENCOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE:
            state = state.setIn(`modalCreate.data.tables.users.ids`.split('.'), Immutable.fromJS(action.payload))
            return state
        case types.CENCOS_MOSTRAR_OCULTAR_MODAL_CARGAR_PRESUPUESTO:
            state = state.setIn(['modalCargarPresupuesto', 'show'], action.payload.show)
            if (!action.payload.show) {
                state = state.set('modalCargarPresupuesto', INITIAL_STATE.get('modalCargarPresupuesto'))
            }
            return state
        default:
            return state
    }
}